module.exports = __webpack_public_path__ + "img/mobile3.a7e3a808.png";